'use strict';

import Swiper from 'swiper';

const SELECTOR_ROOT = '.js-projects-slider';

const initSlider = (root) => {
  if (!(root instanceof Element)) {
    return;
  }

  if (root.dataset.sliderInitialized === '1') {
    return;
  }

  const swiperElement = root.querySelector('.tc-website-projects-slider__swiper');
  const nextElement = root.querySelector('.tc-website-projects-slider__nav--next');
  const prevElement = root.querySelector('.tc-website-projects-slider__nav--prev');

  if (!(swiperElement instanceof Element)) {
    return;
  }

  const wrapperElement = swiperElement.querySelector('.swiper-wrapper');
  if (!(wrapperElement instanceof Element)) {
    return;
  }

  const slideCount = wrapperElement.querySelectorAll('.swiper-slide').length;
  if (!slideCount) {
    return;
  }

  if (slideCount <= 2) {
    root.classList.add('is-nav-hidden-desktop');
  }

  let swiper;
  try {
    swiper = new Swiper(swiperElement, {
      loop: slideCount > 1,
      slidesPerView: 1,
      spaceBetween: 14,
      watchOverflow: false,
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 16
        },
        992: {
          slidesPerView: 2,
          spaceBetween: 16
        }
      }
    });
  } catch (error) {
    // Avoid breaking the rest of the page when slider DOM is incomplete.
    return;
  }

  if (prevElement) {
    prevElement.addEventListener('click', (event) => {
      event.preventDefault();
      swiper.slidePrev();
    });
  }

  if (nextElement) {
    nextElement.addEventListener('click', (event) => {
      event.preventDefault();
      swiper.slideNext();
    });
  }

  let isWheelSliding = false;
  swiperElement.addEventListener('wheel', (event) => {
    if (Math.abs(event.deltaY) < 5) {
      return;
    }

    event.preventDefault();
    if (isWheelSliding) {
      return;
    }

    isWheelSliding = true;
    if (event.deltaY > 0) {
      swiper.slideNext();
    } else {
      swiper.slidePrev();
    }

    window.setTimeout(() => {
      isWheelSliding = false;
    }, 350);
  }, { passive: false });

  root.dataset.sliderInitialized = '1';
};

const init = () => {
  const sliders = document.querySelectorAll(SELECTOR_ROOT);
  if (!sliders.length) {
    return;
  }
  sliders.forEach(initSlider);
};

export default { init };
